import type { JsonSchema } from "../../dashboards/ConfigForm";

/** "Show from" (ADR 0024): this workspace, plus what is mine elsewhere, or all my workspaces. */
export type Source = "here" | "mine" | "all";

export const SOURCE_SCHEMA: JsonSchema = {
  type: "string",
  title: "config.source",
  enum: ["here", "mine", "all"],
};
